import { render, staticRenderFns } from "./headerHome.vue?vue&type=template&id=38ae68ef&"
import script from "./headerHome.vue?vue&type=script&lang=js&"
export * from "./headerHome.vue?vue&type=script&lang=js&"
import style0 from "./headerHome.vue?vue&type=style&index=0&id=38ae68ef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports